import { gql } from '@apollo/client';

export const FETCH_PROCESSES_AREAS_BY_LOCATION = gql`
  query FindAllProcessAreasByLocation($uuid: ID!) {
    findAll: findAllProcessAreasByLocation(uuid: $uuid) {
      processArea
      replacementCost
      replacementTime
      underlyingProcesses
      uuid
    }
  }
`;

export const FETCH_PROCESSES_AREAS_WITH_STRATEGY_BY_LOCATION = gql`
  query FindAllProcessAreasByLocation($uuid: ID!) {
    findAll: findAllProcessAreasByLocation(uuid: $uuid) {
      children: procesess {
        name: process
        replacementCost
        replacementTime
        strategy {
          bcpStatus
          externalMitigation
          finishedGoodsInventory
          grossRevenueExposure
          internalMitigation
          isDefault
          lastUpdate
          lengthOfDisruption
          mitigation
          netRevenueExposure
          onSitesMitigation
          percentageBusinessSupported
          required
          revenueSupportedAnnually
          strategyAge
          summary
          uuid
          finalizedAt
        }
        key: uuid
      }
      name: processArea
      replacementCost
      replacementTime
      strategy {
        bcpStatus
        externalMitigation
        finishedGoodsInventory
        grossRevenueExposure
        internalMitigation
        isDefault
        lastUpdate
        lengthOfDisruption
        mitigation
        netRevenueExposure
        onSitesMitigation
        percentageBusinessSupported
        required
        revenueSupportedAnnually
        strategyAge
        summary
        uuid
        finalizedAt
      }
      underlyingProcesses
      key: uuid
      strategyComment
    }
  }
`;

export const FETCH_PROCESS_AREA_BY_UUID = gql`
  query FindProcessAreaByUuid($uuid: ID!) {
    findProcessAreaByUuid(uuid: $uuid) {
      comment
      procesess {
        comment
        process
        replacementCost
        replacementTime
        strategy {
          bcpStatus
          externalMitigation
          finishedGoodsInventory
          grossRevenueExposure
          internalMitigation
          isDefault
          lastUpdate
          lengthOfDisruption
          mitigation
          netRevenueExposure
          onSitesMitigation
          percentageBusinessSupported
          required
          revenueSupportedAnnually
          strategyAge
          summary
          uuid
        }
        strategyComment
        uuid
      }
      processArea
      replacementCost
      replacementTime
      strategy {
        bcpStatus
        externalMitigation
        finishedGoodsInventory
        grossRevenueExposure
        internalMitigation
        isDefault
        lastUpdate
        lengthOfDisruption
        mitigation
        netRevenueExposure
        onSitesMitigation
        percentageBusinessSupported
        required
        revenueSupportedAnnually
        strategyAge
        summary
        uuid
      }
      strategyComment
      underlyingProcesses
      uuid
    }
  }
`;
export const FETCH_PROCESS_AREA_MITIGATION_OPTIONS = gql`
  query ProcessAreaMitigationOptions($uuid: ID!) {
    processAreaMitigationOptions(uuid: $uuid) {
      name
      productGroups {
        name
        products {
          name
          strategyComment
          totalExternal
          totalInternal
          totalInventory
          totalOnsite
          uuid
        }
        strategyComment
        totalExternal
        totalInternal
        totalInventory
        totalOnsite
        uuid
      }
      strategyComment
      totalExternal
      totalInternal
      totalInventory
      totalOnsite
      uuid
    }
  }
`;

export const FETCH_PROCESSES_MITIGATION_OPTIONS = gql`
  query ProcessMitigationOptions($uuid: ID!) {
    processMitigationOptions(uuid: $uuid) {
      name
      productGroups {
        name
        products {
          name
          strategyComment
          totalExternal
          totalInternal
          totalInventory
          totalOnsite
          uuid
        }
        strategyComment
        totalExternal
        totalInternal
        totalInventory
        totalOnsite
        uuid
      }
      strategyComment
      totalExternal
      totalInternal
      totalInventory
      totalOnsite
      uuid
    }
  }
`;

export const CREATE_PROCESS_AREA = gql`
  mutation createProcessArea($data: CreateProcessAreaInput!) {
    createProcessArea(data: $data) {
      processArea
      replacementCost
      replacementTime
      uuid
    }
  }
`;

export const UPDATE_PROCESS_AREA = gql`
  mutation updateProcessArea($data: UpdateProcessAreaInput!) {
    updateProcessArea(data: $data) {
      processArea
      replacementCost
      replacementTime
      uuid
    }
  }
`;

export const DELETE_PROCESS_AREA = gql`
  mutation deleteProcessArea($uuid: ID!) {
    deleteProcessArea(uuid: $uuid) {
      processArea
      replacementCost
      replacementTime
      uuid
    }
  }
`;
